<template>
  <div class="flex flex-col">
    <div
      class="h-12 bg-orange-500 rounded-t-md flex items-center justify-center relative"
    >
      <div
        class="bg-white rounded-full size-14 flex items-center justify-center absolute top-5 z-10"
      >
        <div
          class="circle-orange size-12 rounded-full flex items-center justify-center z-20"
        >
          <Icon :name="props.icon" class="text-orange-500 size-7 z-30" />
        </div>
      </div>
    </div>
    <div class="bg-white rounded-b-md px-2 py-6" style="height: 200px;">
      <h3 class="h-12 text-md md:text-xl font-bold text-orange-500 mt-2">
        {{ props.title }}
      </h3>
      <p class="text-xs font-light text-slate-600 mt-3">
        {{ props.content }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    title?: string
    content?: string
    icon?: string
  }>(),
  {
    title: '',
    content: '',
    icon: '',
  },
)
</script>

<style scoped>
.circle-orange {
  background-color: #ffe1cc;
}
.promise-card-content {
  height: 150px;
}
</style>
